import { render, staticRenderFns } from "./certificate.vue?vue&type=template&id=16f76dbb&scoped=true"
import script from "./certificate.vue?vue&type=script&lang=js"
export * from "./certificate.vue?vue&type=script&lang=js"
import style0 from "./certificate.vue?vue&type=style&index=0&id=16f76dbb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f76dbb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f76dbb')) {
      api.createRecord('16f76dbb', component.options)
    } else {
      api.reload('16f76dbb', component.options)
    }
    module.hot.accept("./certificate.vue?vue&type=template&id=16f76dbb&scoped=true", function () {
      api.rerender('16f76dbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesman/staffManage/staffForm/certificate.vue"
export default component.exports